// Theme Main JS
import '../vendor/brooklyn';

// Styles
import '../../styles/style.scss';

// Scripts
import '../vendor/slick/slick.js';
import '../vendor/ProxyLink.js';
import '../vendor/TimedPopUp.js';
import '../vendor/parsley.js';
import Tabs from '../components/tabs.js';
import '../components/gsap-collapse.js';
//import '../components/sparkle';
import '../components/knitkit.js';
import '../components/input.js';
import '../components/header.js';
import '../components/drawer.js';
import '../components/facets.js';
/* import '../components/$.ClipIt.js'; */
import NewsletterForm from '../components/newsletter-form.js';
import '../sections/slideshow.js';
import '../sections/images-with-text.js';
import '../sections/collaboration.js';
import '../sections/impact-slideshow.js';
import '../sections/hero-cards.js';
import '../sections/collection-carousel.js';
import '../snippets/contact-form.js';
import '../sections/featured-products-slider.js';
import '../sections/featured-description.js';
import '../sections/template_product.js';
import '../sections/newsletter-popup.js';
import '../sections/three-images.js';
import '../sections/instagram-feed.js';
import '../sections/template_cart.js';
import '../snippets/wishlist.js';
import '../snippets/dataLayer.js';
import '../sections/countdown.js';
import '../sections/product-video.js';
import '../sections/product-composition.js';
import '../sections/countdown.js';

$(document).on('ready', function() {
    Tabs();
    NewsletterForm();

    if(typeof window.Ajaxinate !== 'undefined' && document.getElementById('AjaxinateContainer')) {

        var anchorStart = window.location.href.indexOf('#');
        var itemID = anchorStart != -1 ? window.location.href.substr(anchorStart) : ''
        var preLoadingEnded = true; // Flag to check if were loading back pages
        var ajaxPageParamStart = window.location.href.indexOf('?i=');
        var ajaxPageParamEnd = anchorStart != -1 ? window.location.href.length - anchorStart : undefined;
        var ajaxPageNumber = ajaxPageParamStart != -1 ? parseInt(window.location.href.substr(ajaxPageParamStart, ajaxPageParamEnd).replace('?i=', '')) : false;

        var preLoadNextPage = function() {
            window.endlessScroll.currentPage++
            window.endlessScroll.pagesToLoad--;

            window.setTimeout(function(){
                if(window.endlessScroll.nextPageLinkElement){
                    window.endlessScroll.nextPageUrl = window.endlessScroll.nextPageLinkElement.getAttribute('href');
                    window.endlessScroll.loadMore();
                }
            }, 10); // Please lord of javascript forgive me for this!

            if(!window.endlessScroll.pagesToLoad) {
                preLoadingEnded = true;
            }
        }

        window.endlessScroll = new Ajaxinate({
          container: '#AjaxinateContainer',
          pagination: '#AjaxinatePagination',
          method: 'scroll',
          callback: function(requestURL){
                var $proxyLinks = $('#AjaxinateContainer').find('[data-link-proxy]');

                if($proxyLinks.length > 1) {
                    $proxyLinks.off('click');

                    $proxyLinks.ProxyLink({
                        excludes: ['.slick-dots', '.product-tile__variant', '.swym-add-to-wishlist-view-product' ],
                        onBeforeUnload: function($proxyLink) {
                            const itemID = $proxyLink.data('pid');

                            if(itemID) {
                                const requestedPageNum = requestURL.substr(requestURL.indexOf('?page=')).replace('?page=', '');
                                history.replaceState({}, 'page ' + requestedPageNum, '?i='+requestedPageNum + '#' + itemID);
                            }
                        }
                    });
                }

                // Init wishlist buttons
                document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

                // Scroll back to latest position
                var requestedPageNum = requestURL.substr(requestURL.indexOf('?page=')).replace('?page=', '');

                    if(preLoadingEnded) {
                        window.endlessScroll.currentPage = requestedPageNum;
                        history.replaceState({}, 'page ' + requestedPageNum, '?i='+requestedPageNum + itemID);
                    }

                    if(!window.endlessScroll.pagesToLoad) {
                        const headersHeight = $('.site-header').outerHeight(true);

                        if(itemID) {
                            var itemTop = $(itemID).offset().top - headersHeight;
                            window.scrollTo({left:0, top:itemTop, behavior: 'smooth'});
                            itemID = '';
                        }
                    }

                    if(window.endlessScroll.pagesToLoad) {
                        preLoadNextPage();
                    }
                }
        });

        window.endlessScroll.currentPage = 1;

        if(ajaxPageNumber) {
            window.scrollTo({left:0, top: 0});
            preLoadingEnded = false;
            window.endlessScroll.pagesToLoad = ajaxPageNumber - 1;
            preLoadNextPage();
        }
    }

    $('[data-timed-popup]').TimedPopup();

    const $orderLists = $('[data-order-list]');
    if($orderLists.length) {
        $orderLists.each(function(){
            const $list = $(this);
            $list.find('[data-order-number]').sort(function(a, b) {
                return +a.dataset.orderNumber - +b.dataset.orderNumber;
            })
            .appendTo($list);
        });
        window.setTimeout(function(){
            $orderLists.attr('data-order-list', 'ready');
        }, 50);
    }

    $('a').on('click', function(e) {
        if (this.hash !== "") {
            e.preventDefault();
            var hash = this.hash;
            var header = 'body .header-bg';
            var headerHeight = $(header).outerHeight();
            var topPosition = $(hash).offset().top  - headerHeight;
            $('html,body').animate({scrollTop: topPosition }, 'slow', function(){
                window.location.hash = hash;
            });
        }
    })

});




